import { combineReducers } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import loginStore from "../store/login";
import appStore from "../store/app";
import workgroupStore from "../store/workgroup";
import meetingStore from "../store/meeting";
import documentStore from "../store/document";
import policyStore from "../store/policy";
import progressStore from "../store/progress";
import logStore from "../store/log";
import chatStore from "../store/chat";
import workspaceStore from "../store/workspace";
import adminLoginStore from "../store/admin/adminLogin";
import adminSettingStore from "../store/admin/adminSetting";
import adminHomeStore from "../store/admin/adminHome";
import adminDeptStore from "../store/admin/adminDept";
import adminWhiteLabelStore from "../store/admin/adminWhiteLabel";
import adminPositionRoleStore from "../store/admin/adminPositionRole";
import adminWorkgroupStore from "../store/admin/adminWorkgroup";
import adminContentStore from "../store/admin/adminContent";
import adminLogStore from "../store/admin/adminLog";
import adminConfigStore from "../store/admin/adminConfig";
import adminStorageStore from "../store/admin/adminStorage";

// 루트 리듀서
const rootReducer = combineReducers({
  loginStore,
  appStore,
  progressStore,
  workgroupStore,
  documentStore,
  meetingStore,
  policyStore,
  logStore,
  chatStore,
  adminLoginStore,
  adminSettingStore,
  adminHomeStore,
  adminDeptStore,
  adminWhiteLabelStore,
  adminPositionRoleStore,
  adminWorkgroupStore,
  adminContentStore,
  adminLogStore,
  adminConfigStore,
  adminStorageStore,
  workspaceStore,
});

// 루트 리듀서의 반환값를 유추
// 추후 이 타입을 컨테이너 컴포넌트에서 불러와서 사용해야 하므로 내보내줌
export type RootState = ReturnType<typeof rootReducer>;
type StateSelector<T> = (state: RootState) => T;
type EqualityFn<T> = (left: T, right: T) => boolean;

export function useRootState<T>(
  selector: StateSelector<T>,
  equalityFn?: EqualityFn<T>
): any {
  return useSelector(selector, equalityFn);
}

//configureStore를 사용해야 extraReducers 사용 가능
export const store = configureStore({
  reducer: rootReducer,
});
//export default store;

export type AppDispatch = typeof store.dispatch;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default rootReducer;
